module.exports = __webpack_public_path__ + "img/PDAC1_Endothelial.93699f5d.png";